import querystring from 'querystring'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import pick from 'lodash/pick';
import logServiceSdkImplicitCreationDeprecation from '../util/log-deprecation';
import serviceHTTPHelper from '../service-http-helper';
import ServiceSDKModule from '../service-sdk';
export var BankingProductsSDKModule = function BankingProductsSDKModule(ServiceSDK, config) {
  var bankingProductsRoute = function bankingProductsRoute(endpoint) {
    return ServiceSDK.nwApiRoute(config.bankingProductsBaseUrl, 'banking-products', 1, endpoint);
  };

  var service = serviceHTTPHelper(ServiceSDK, bankingProductsRoute);

  var search = function search(payload) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var serverRequest = arguments.length > 2 ? arguments[2] : undefined;
    var queryParams = querystring.stringify(params);
    var endpoint = queryParams ? "/search?".concat(queryParams) : '/search';
    return service.post(endpoint, payload, serverRequest);
  };

  var rates = function rates() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var serverRequest = arguments.length > 1 ? arguments[1] : undefined;
    return service.get('/rates', query, serverRequest);
  };

  var namedQuery = function namedQuery(name) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var serverRequest = arguments.length > 3 ? arguments[3] : undefined;
    var queryParams = querystring.stringify(params);
    var baseUrl = "/named_query/".concat(name);
    var endpoint = queryParams ? "".concat(baseUrl, "?").concat(queryParams) : baseUrl;
    return service.post(endpoint, payload, serverRequest);
  };

  var institutions = function institutions(institutionId) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        zipCode = _ref.zipCode;

    var serverRequest = arguments.length > 2 ? arguments[2] : undefined;
    var query = {};

    if (zipCode) {
      query.zipCode = zipCode;
    }

    return service.get("/institutions/".concat(institutionId), query, serverRequest);
  };

  var branches = function branches(zipCode) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        institutionId = _ref2.institutionId;

    var serverRequest = arguments.length > 2 ? arguments[2] : undefined;
    var url = "/branches/".concat(zipCode);

    if (institutionId) {
      url = "".concat(url, "/").concat(institutionId);
    }

    return service.get(url, {}, serverRequest);
  };

  return {
    rates: rates,
    search: search,
    namedQuery: namedQuery,
    institutions: institutions,
    branches: branches
  };
};
/*
Return a BankingProductsSDK library instance.

config:
- applicationID: your FE app's unique application ID
- clientID: your FE app's unique client ID
- bankingProductsBaseUrl: the bankingProducts flag base URL for your current environment.
*/

export default (function (ServiceSDK, config) {
  if (!ServiceSDK) {
    logServiceSdkImplicitCreationDeprecation();
    ServiceSDK = ServiceSDKModule(pick(config, ['applicationID', 'clientID', 'xhrTimeout']));
  }

  return BankingProductsSDKModule(ServiceSDK, pick(config, ['bankingProductsBaseUrl', 'clientID']));
});